import React, {useEffect, useState} from "react";
import {Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import TextFieldValidation from "../table/customer-detales/TextFieldValidation";
import ButtonExit from "../button/ButtonExit";
import ButtonAdd from "../button/ButtonAdd";

const ModalPatterns = ({
                           open,
                           onClose,
                           handleSubmit,
                           initValue,
                           title,
                           loading,
                       }) => {

    const [formState, setFormState] = useState(initValue)

    useEffect(() => {
        setFormState(initValue)
    }, [initValue])

    const handleClose = () => {
        setFormState(initValue)
        onClose()
    }

    const submit = () => {
        handleSubmit(formState, handleClose)
    }
    return (
        <Dialog open={open} PaperProps={{
            style: {
                minWidth: "400px",
                borderRadius: 8,
            }
        }}>
            <DialogTitle textAlign="center">{title}</DialogTitle>
            <DialogContent>
                <TextFieldValidation
                    name={"name"}
                    type={"text"}
                    value={formState?.name}
                    label={"Наименование"}
                    setCurrValues={setFormState}
                    required={false}
                />
                <TextFieldValidation
                    name={"patternL"}
                    type={"text"}
                    value={formState?.patternL}
                    label={"Паттерн длины"}
                    setCurrValues={setFormState}
                    required={false}
                />
                <TextFieldValidation
                    name={"patternW"}
                    type={"text"}
                    value={formState?.patternW}
                    label={"Паттерн ширины"}
                    setCurrValues={setFormState}
                    required={false}
                />
            </DialogContent>
            <DialogActions sx={{p: '1.25rem'}}>
                <ButtonExit text={"Отменить"} onClick={handleClose}/>
                <ButtonAdd loading={loading} text={"Сохранить"} onClick={submit}/>
            </DialogActions>
        </Dialog>
    );
}
export default ModalPatterns